import { render, staticRenderFns } from "./ActivityBlock.vue?vue&type=template&id=3b85c22c&"
import script from "./ActivityBlock.vue?vue&type=script&lang=js&"
export * from "./ActivityBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports